"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLogsPublicApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var configuration_1 = require("../domain/configuration");
var logger_1 = require("../domain/logger");
var sender_1 = require("../domain/sender");
function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0, browser_core_1.createContextManager)();
    var customLoggers = {};
    var beforeInitSendLog = new browser_core_1.BoundedBuffer();
    var sendLogStrategy = function (message, currentContext) {
        beforeInitSendLog.add(function () { return sendLogStrategy(message, currentContext); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var sender = (0, sender_1.createSender)(sendLog);
    var logger = new logger_1.Logger(sender);
    return (0, browser_core_1.makePublicApi)({
        logger: logger,
        init: (0, browser_core_1.monitor)(function (initConfiguration) {
            if ((0, browser_core_1.canUseEventBridge)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = (0, configuration_1.validateAndBuildLogsConfiguration)(initConfiguration);
            if (!configuration) {
                return;
            }
            sendLogStrategy = startLogsImpl(configuration, sender).send;
            getInitConfigurationStrategy = function () { return (0, browser_core_1.deepClone)(initConfiguration); };
            beforeInitSendLog.drain();
            isAlreadyInitialized = true;
        }),
        getLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.get),
        setLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.set),
        addLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.add),
        removeLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.remove),
        createLogger: (0, browser_core_1.monitor)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            var sender = (0, sender_1.createSender)(sendLog, conf.handler, conf.level, (0, browser_core_1.assign)({}, conf.context, {
                logger: { name: name },
            }));
            customLoggers[name] = new logger_1.Logger(sender);
            return customLoggers[name];
        }),
        getLogger: (0, browser_core_1.monitor)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0, browser_core_1.monitor)(function () { return getInitConfigurationStrategy(); }),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0, browser_core_1.assign)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                browser_core_1.display.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
    function sendLog(message) {
        sendLogStrategy(message, (0, browser_core_1.combine)({
            date: Date.now(),
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
        }, globalContextManager.get()));
    }
}
exports.makeLogsPublicApi = makeLogsPublicApi;
//# sourceMappingURL=logsPublicApi.js.map